<template>
  <div class="section-content admin-content">
    <!-- Titulo de Pagina -->
    <div class="loading" v-if="patientLoading">
      <md-progress md-indeterminate></md-progress>
      <span>Cargando mapa de Pacientes para la comuna seleccionada...</span>
    </div>
    <div class="main-content">
      <!-- Graficos -->

      <!-- Resultados -->
      <div class="table-results display-flex justify-content-between align-items-start">
        <div class="title-results">
          <h3>Resultados de Pacientes
            <span class="bubble">{{ patientsWithCoords.length + patientsWithoutCoords }}</span>
          </h3>
          <!-- <p>Pacientes Totales:
            <strong>+2.300.000</strong>
          </p> -->
        </div>
      </div>

      <div class="alert alert-info" style="
    background: #39b7c0;
    color: white;
    padding: 10px;
    margin-bottom: 20px;
">Con el fin de proteger la privacidad de nuestros Pacientes no mostramos la identidad de ellos ni su ubicación exacta, la ubicación es modificada de manera al azar en un radio de 2km de la registrada en nuestros sistemas.</div>

      <!-- Mapa OpenStreetMap -->
      <div class="map-results">
        <!-- Estado de carga del mapa -->
        <div v-if="mapLoading" class="map-loading">
          <div class="loading-content">
            <md-spinner md-indeterminate class="md-accent" style="width: 40px; height: 40px;"></md-spinner>
            <p>Cargando mapa y ubicaciones...</p>
            <p class="loading-detail">Procesando {{ companiesWithCoords.length }} empresas y {{ patientsWithCoords.length }} pacientes con ubicación</p>
          </div>
        </div>

        <div v-else-if="mapReady" class="map-ready-indicator">
          <div class="ready-content">
            <md-icon class="ready-icon">check_circle</md-icon>
            <p>Mapa listo para usar</p>
            <p class="ready-detail">{{ patientsWithCoords.length }} pacientes cargados</p>
          </div>
        </div>

        <!-- Controles del mapa -->
        <div class="map-controls">
          <md-button class="md-icon-button fullscreen-btn" @click="openFullscreenMap">
            <md-icon>fullscreen</md-icon>
          </md-button>
        </div>

        <div id="map-container" ref="mapContainer" style="height: 500px; width: 100%; border: 1px solid #ddd; border-radius: 4px;"></div>
        <div class="map-info">
          <!-- <p><strong>Empresas encontradas:</strong> {{ companiesWithCoords.length }} ({{ companiesWithoutCoords }} sin coordenadas)</p> -->
          <p><strong>Pacientes con ubicación:</strong> {{ patientsWithCoords.length }} ({{ patientsWithoutCoords }} sin coordenadas)</p>
          <p><strong>Pacientes totales en comuna:</strong> {{ patientsWithCoords.length + patientsWithoutCoords }}</p>
          <p><strong>Estado:</strong>
            <span v-if="mapLoading" style="color: #ff9800;">Cargando...</span>
            <span v-else-if="mapReady" style="color: #4caf50;">Listo</span>
            <span v-else style="color: #f44336;">No inicializado</span>
          </p>
          <p><strong>Nota:</strong> Los marcadores se agrupan automáticamente para mejor rendimiento</p>
        </div>
      </div>

      <!-- Filtros de Tabla -->
      <div class="table-filters" style="    padding: 20px;
    background: #fafafa;" >
        <b> Calcule su alcance estimado, unicamente puede seleccionar comunas donde ud cuenta con una consulta / BOX : </b>
        <div style="padding: 20px;background: #dac50b6e;" v-if="this.datatable.filters.comunities.length == 0">Usted no cuenta con consultas / BOX </div>

        <md-input-container class="select-border filter-item" v-if="datatable.filters.comunities.length">
                 <label>Comuna</label>
          <md-select placeholder="Comuna" v-model="datatable.filters.options.comunity_filter">
            <md-option v-for="(row, rowIndex) in datatable.filters.comunities" :key="rowIndex" :value="row.id">
              {{ row.name }}
            </md-option>
          </md-select>
        </md-input-container>
      </div>

      <!-- Stats -->
      <div class="total-stats">
        <div class="row" >
          <div class="col-stats">
            <div class="stat-item">
              <h4>Alcance</h4>
              <h3 class="stat-price">
                <span class="sign"></span>{{ this.datatable.filters.pages.total ? patientsWithCoords.length + patientsWithoutCoords : "Seleccione una comuna" }}
                <div class="type"></div>
              </h3>
            </div>
          </div>
          <div class="col-stats">
            <div class="stat-item">
              <h4>Efectividad estimada</h4>
              <h3 class="stat-price">
                <span class="sign"></span>{{ this.datatable.filters.pages.total ? rounded((patientsWithCoords.length + patientsWithoutCoords)*0.82) :  "Seleccione una comuna" }}
                <div class="type"></div>
              </h3>
            </div>
          </div>
        </div>
      </div>
     <md-button class="md-raised md-primary" @click="soon()">Promocionar</md-button>
    </div>
  <md-snackbar md-position="bottom center" ref="snackbar" md-duration="8000">
    <span>Hemos comenzado tu proceso de aprobación para publicar, Recibiras un correo una vez haya concluido el proceso.</span>
    <md-button class="md-accent" md-theme="light-blue" @click="$refs.snackbar.close()">OK</md-button>
  </md-snackbar>

<md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialog1" style="z-index: 10010;">
  <form novalidate>
  <md-dialog-content>
    <b>Vista Previa</b>
    <md-button-toggle md-single>
      <md-button @click="preview(1)">Correo Electronico</md-button>
      <md-button @click="preview(2)">WhatsApp</md-button>
      <md-button @click="preview(3)">Notificación Push</md-button>
    </md-button-toggle>
    <div v-if="preview_item == 1" class="col-md-12 col-sm-12 col-xs-12 no-padder">
      <br>
      <b>Seleccione una opción</b>
      <div>
        <md-radio v-model="typeEmail" md-value="default">
          <strong>
            Enviar correo predeterminado
          </strong>
        </md-radio>
        <md-radio v-model="typeEmail" md-value="person">
          <strong>
            Enviar correo personalizado
          </strong>
        </md-radio>
      </div>
      <br>
      <div style="padding: 0">
          <md-layout md-gutter>
        <div class="sc-iRbamj hQVZHze">
        <div v-if="typeEmail === 'person'" style="padding: 0">
          <br>
           <md-layout md-gutter>
              <md-input-container>
                <label>Correo</label>
                <md-field>
                  <md-input v-model="form.to" />
                </md-field>
              </md-input-container>
              <md-input-container>
                <label>Mensaje</label>
                <md-field>
                  <md-textarea v-model="form.text" />
                </md-field>
              </md-input-container>
              <br>
              <md-input-container>
                <md-field>
                <label>Ingresar una imagen</label>
                  <md-file v-model="form.image" />
                </md-field>
              </md-input-container>
          </md-layout>
          <br>
        </div>
          <div v-if="typeEmail === 'default'" class="sc-jlyJG jiSlDO">
            <span class="sc-csuQGl ezfjWK" style="font-weight: bold;">
              {{ the_doctor.specialities[0].name }}
              {{ the_doctor.name + " "+ (the_doctor.lastname ? the_doctor.lastname : the_doctor.lastname2) }}
            </span>
          </div>
          <div v-if="typeEmail === 'default'" class="sc-gipzik eLaYeg">
            <div class="sc-hzDkRC jHeljQ">
              <div class="sc-jhAzac cypPtq">
                <div class="sc-fBuWsC jLtcjp">
                  Prestador Destacado
                </div>
                <div class="sc-fMiknA enniBG">
                  Te invitamos a conocer a nuestro Prestador de Salud en convenio con ColaboraMed
                  atención preferencial con bonificación hasta del 80% del Co-Pago, para pago online.
                </div>
              </div>
            </div>
          </div>
        </div>
        </md-layout>
      </div>
    </div>
    <div v-if="preview_item == 2" class="desktop_only" style="height: 450px;overflow:hidden; text-align:center">
      <div class="marvel-device iphone-x" style="margin-top:15px;" >
          <div class="notch">
              <div class="camera"></div>
              <div class="speaker"></div>
          </div>
          <div class="top-bar"></div>
          <div class="sleep"></div>
          <div class="bottom-bar"></div>
          <div class="volume"></div>
          <div class="overflow">
              <div class="shadow shadow--tr"></div>
              <div class="shadow shadow--tl"></div>
              <div class="shadow shadow--br"></div>
              <div class="shadow shadow--bl"></div>
          </div>
          <div class="inner-shadow"></div>
          <div class="screen">

            <div class="screen-container">
              <div class="status-bar">
                <div class="time"></div>
                <div class="battery">
                  <i class="zmdi zmdi-battery"></i>
                </div>
                <div class="network">
                  <i class="zmdi zmdi-network"></i>
                </div>
                <div class="wifi">
                  <i class="zmdi zmdi-wifi-alt-2"></i>
                </div>
                <div class="star">
                  <i class="zmdi zmdi-star"></i>
                </div>
              </div>
              <div class="chat">
                <div class="chat-container">
                  <div class="user-bar">
                    <div class="back">
                      <i class="zmdi zmdi-arrow-left"></i>
                    </div>
                    <div class="avatar">
                      <img src="https://avatars2.githubusercontent.com/u/398893?s=128" alt="Avatar">
                    </div>
                    <div class="name">
                      <span>Paciente</span>
                      <span class="status">en linea</span>
                    </div>
                    <div class="actions more">
                      <i class="zmdi zmdi-more-vert"></i>
                    </div>
                    <div class="actions attachment">
                      <i class="zmdi zmdi-attachment-alt"></i>
                    </div>
                    <div class="actions">
                      <i class="zmdi zmdi-phone"></i>
                    </div>
                  </div>
                  <div class="conversation">
                    <div class="conversation-container">
                      <div class="message sent">
                        <span style="font-size: 18px; line-height: 21px;">Te invitamos a conocer a nuestro Prestador de Salud <b>{{ the_doctor.name + " "+ (the_doctor.lastname ? the_doctor.lastname : "") }}</b> especialista en <b><font v-for="(row, rowIndex) in the_doctor.specialities" :key="rowIndex">{{row.name}}{{ the_doctor.specialities.length > (rowIndex+1) ? ", " : ""}}</font></b> para agendar con el puedes presionar el siguiente botón:

      <a href="javascript:;" class="btn btn-primary" style="
          color: blue;
          text-decoration: none;
          display:block;
          margin-top: 20px;
      ">Agendar con <b>
      {{ the_doctor.name + " "+ (the_doctor.lastname ? the_doctor.lastname : "") }}</b> </a>


      </span>
                        <span class="metadata">
                            <span class="time"></span><span class="tick"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063" y="2076"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" fill="#4fc3f7"/></svg></span>
                        </span>
                      </div>
                    </div>
                    <form class="conversation-compose">
                      <div class="emoji">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="smiley" x="3147" y="3209"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.153 11.603c.795 0 1.44-.88 1.44-1.962s-.645-1.96-1.44-1.96c-.795 0-1.44.88-1.44 1.96s.645 1.965 1.44 1.965zM5.95 12.965c-.027-.307-.132 5.218 6.062 5.55 6.066-.25 6.066-5.55 6.066-5.55-6.078 1.416-12.13 0-12.13 0zm11.362 1.108s-.67 1.96-5.05 1.96c-3.506 0-5.39-1.165-5.608-1.96 0 0 5.912 1.055 10.658 0zM11.804 1.01C5.61 1.01.978 6.034.978 12.23s4.826 10.76 11.02 10.76S23.02 18.424 23.02 12.23c0-6.197-5.02-11.22-11.216-11.22zM12 21.355c-5.273 0-9.38-3.886-9.38-9.16 0-5.272 3.94-9.547 9.214-9.547a9.548 9.548 0 0 1 9.548 9.548c0 5.272-4.11 9.16-9.382 9.16zm3.108-9.75c.795 0 1.44-.88 1.44-1.963s-.645-1.96-1.44-1.96c-.795 0-1.44.878-1.44 1.96s.645 1.963 1.44 1.963z" fill="#7d8489"/></svg>
                      </div>
                      <input class="input-msg" name="input" placeholder="Type a message" autocomplete="off" autofocus />
                      <div class="photo">
                        <i class="zmdi zmdi-camera"></i>
                      </div>
                      <button class="send">
                          <div class="circle">
                            <i class="zmdi zmdi-mail-send"></i>
                          </div>
                        </button>
                    </form>
      </div>
          </div>
          </div>
          </div>
          </div>
      </div>
    </div>
    <div v-if="preview_item == 3" style="height:450px;overflow:hidden" class="desktop_only">
      <div class="sc-jDwBTQ egkRpC" style="margin-top:10px"><div class="sc-gPEVay dSmbrN">
        <div class="sc-iRbamj hQVZHz">
          <div class="sc-jlyJG jiSlDO">
            <span class="sc-csuQGl ezfjWK" style="font-weight: bold;">AMOL</span><span class="sc-Rmtcm deQnlS">now</span>
          </div>
          <div class="sc-gipzik eLaYeg">
            <div class="sc-hzDkRC jHeljQ">
              <div class="sc-jhAzac cypPtq">
                <div class="sc-fBuWsC jLtcjp">
                  Prestador Destacado
                </div>
                <div class="sc-fMiknA enniBG">
                  Te invitamos a conocer a nuestro Prestador de Salud
                  {{ the_doctor.name + " "+ (the_doctor.lastname ? the_doctor.lastname : "") }} especialista en
                  <font v-for="(row, rowIndex) in the_doctor.specialities" :key="rowIndex">
                    {{row.name}}{{ the_doctor.specialities.length > (rowIndex+1) ? ", " : ""}}
                  </font>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sc-fAjcbJ dgBCNv">
          <div class="sc-caSCKo bFdPyK">Agendar Hora</div></div></div></div>
        </div>
        <div class="movil_only">
         <div style="padding: 20px;background: #dac50b6e;" >No puedes visualizar las vistas previas en un dispositivo movil debido a que para generar una vista previa fidedigna se utiliza la misma resolucion y proporcion que un dispositivo movil. </div>
         </div>

        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-primary btn--cancel" @click.native="closeDialog('dialog1')">Cerrar</md-button>
          <md-button v-if="preview_item == 1" class="md-primary btn--save btn--blue" @click.native="sendEmail()">
            Enviar
          </md-button>
          <md-button v-if="preview_item > 1" class="md-primary btn--save btn--blue" @click.native="soon2()">
            Publicar
          </md-button>
        </md-dialog-actions>
      </form>
    </md-dialog>

    <!-- Modal para mapa en pantalla completa - NUEVO -->
    <md-dialog ref="fullscreenMap" class="fullscreen-map-modal" style="width: 100vw; height: 100vh; max-width: 100%; max-height: 100%;">
      <md-dialog-title style="position: fixed; top: 0; left: 0; right: 0; background: white; z-index: 10000; padding: 16px 24px; border-bottom: 1px solid #ddd; display: flex; justify-content: space-between; align-items: center;">
        <span>Mapa de Empresas - Vista Completa</span>
        <md-button class="md-icon-button md-dense" @click="closeFullscreenMap">
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content style="padding: 0; margin: 0; width: 100%; height: 100%;">
        <div id="fullscreen-map-container" style="width: 100%; height: 100%;"></div>
      </md-dialog-content>
    </md-dialog>

  </div>

</template>
<script>

import {admin,public_api, doctor} from '../../config/api';
const swal = require("sweetalert2")
const _ = require('lodash')
import moment from 'moment'
import Form from 'vform'

export default {
  mounted(){
    // get Patients by role
   //this.getPatients()

    // get Countries
   this.getComunities()
    // get range Age limit
    // get count patients
    this.$http.get('/doctor/me', {
        headers: {
            Authorization : 'Bearer '+ this.$auth.getToken(),
        }
    }).then(response => {
        if(response.data.status == "OK"){
            let data = response.data.data;
            console.log(data)
            this.the_doctor = data;
        }
    });

    // Inicializar el mapa después de que se monte el componente
    this.$nextTick(() => {
      setTimeout(() => {
        this.initMap();
      }, 100);
    });
  },
  data: () => ({
    form: new Form ({
        to: '',
        name: '',
        text: '',
        image: null,
    }),
    typeEmail: 'default',
    communes: {
      "8261129": 2966,
      "8261144": 2678,
      "8261278": 9554,
      "8261279": 3445,
      "8261311": 11952,
      "8261384": 9887,
      "8261454": 3650,
      "6693568": 24663,
      "6693599": 9885,
      "8261423": 23666,
      "8261139": 2601,
      "8261226": 7603,
      "8261207": 16885,
      "8261383": 9885,
      "8261438": 24775,
      "8261165": 1896,
      "8261339": 4663,
      "8261369": 19887,
      "8261397": 9998,
      "8261398": 6889,
      "8261399": 7884,
      "8261400": 37162,
      "8261432": 9603,
      "8261421": 12886,
      "8261372": 9775,
      "8261405": 57995,
      "8261316": 3556,
      "8261407": 3556,
      "8261410": 29521,
      "8261428": 31445,
      "8261390": 7589,
      "8261156": 4552,
      "8261174": 17890,
      "8261194": 15992,
      "8261434": 25089,
      "8261178": 39554,
      "8261157": 16247,
      "8261413": 9896,
      "8261414": 39774,
      "8261436": 21550,
      "8261431": 9887,
      "8261416": 8061,
      "8261417": 10898,
      "8261418": 11445,
      "8261419": 17552,
      "8261377": 11669,
      "8261158": 3678,
      "8261395": 59887,
      "8261380": 29773,
      "8261346": 9603,
      "8261364": 890,
      "8261231": 3885,
      "8261457": 1204,
      "8261332": 1266,
      "8261285": 4856,
      "8261249": 22934,
      "8261239": 29716,
      "8261250": 3852
    },
    // Variables para el mapa
    map: null,
    fullscreenMap: null,
    markerClusterGroup: null,
    fullscreenMarkerClusterGroup: null,
    mapCenter: [-33.4489, -70.6693],
    mapZoom: 7,
    // Estados de carga del mapa
    mapLoading: false,
    mapReady: false,
    isFullscreen: false,

    companies: [],
    patients: [], // RESTAURADO: Array para pacientes
    officeLocation: false,
    patientLoading: false,
    the_doctor : {
      code : '',
      name : '',
      lastname : '',
      lastname2 : '',
      email : '',
      phone : '',
      password : '',
      password_confirmation : '',
      notification_appointment : false,
      notification_mail : false,
      notification_sms : false,
      type: 'doctor',
      specialities: [],
      region: {label:'',value:''},
      city: {label:'',value:''},
      bon_particular: 1,
      bon_fonasa: 1,
      bon_isapre: 1
    },
    preview_item: null,
    is_doctor: null,
    selected: [],
		selectAll: false,
    newComment: "",
    show_charts: false,
    total_reserves: 0,
    total_diaries: 0,
    countPatients: 0,
    data: {},
    graphs: {},
    show_map: true,
    graph_models: [4, 0, 2, 3],
    graph_types: [
      "N° Pacientes vs Prevision",
      "N° Bonos por Prevision vs Tiempo",
      "N° Pacientes vs Comuna",
      "Ahorro total vs Prevision",
      "Gasto, Descuento, Ahorro vs Tiempo"
    ],
    graph_slots: [
      {}, {}, {}, {}
    ],
    totals: [],
    datatable: {
      filters: {
        search: {
          query: '',
          queryIsDirty: false,
          isCalculating: false,
          isQuery: false
        },
        visible: false,
        rows: [
          { value: 10, label: 'Mostrar 10' },
          { value: 20, label: 'Mostrar 20' },
          { value: 50, label: 'Mostrar 50' },
          { value: 100, label: 'Mostrar 100' },
          { value: 150, label: 'Mostrar 150' },
          { value: 200, label: 'Mostrar 200' },
          { value: 250, label: 'Mostrar 250' },
          { value: 300, label: 'Mostrar 300' },
        ],
        row_selected: 1500,
        orderBy: [
          { value: '0', label: 'Ordenar Por' },
          { value: 'name', label: 'Nombre' },
          { value: 'rut', label: 'Rut' },
          { value: 'country', label: 'País' },
        ],
        countries: [],
        provinces: [],
        comunities: [],
        patient_types: [],
        previsions: [],
        boxes: [],
        ages: [],
        options: {
          country_filter: 0,
          province_filter: 0,
          comunity_filter: 0,
        },
        pages: {
          last_page: null,
          current_page: 1,
          first_page: 1,
          next_page_url: '',
          prev_page_url: ''
        }
      },
      total: {
        reserves: [],
        diaries: [],
        prices: [],
        discounts: [],
        final_prices: []
      }
    },
    currentIndex: -1,
    patient_edit: {
      name: '',
      lastname: '',
      lastname2: '',
      phone: '',
      prevision_id: '',
      composensation_box_id: '',
      birth_date: '',
      date: '',
      currentDate: '',
    },
    previsions: [],
    disabledPrevisions: true,
    boxes: [],
    disabledBoxes: true,
    patient_btn_edit: false,
  }),

  computed: {
    user() {
        return this.$store.getters.user;
    },
    options() {
      return this.$store.getters.user.options
    },
    paramsForIframe(){
      let url = "?name="+ encodeURI(this.the_doctor.name + " "+ (this.the_doctor.lastname ? this.the_doctor.lastname : ""))
      this.the_doctor.specialities.forEach(function(v, i){
        url = url+"&specs[]="+encodeURI(v.name);
      });
       return url;
    },
    comunitySelected(){
      let filter = this.datatable.filters.comunities.filter((x) => {return x.id == this.datatable.filters.options.comunity_filter});

      console.log("filter",filter);
      return filter.length == 1 ? filter[0] : null;
    },
    // NUEVO: Filtrar empresas con coordenadas
    companiesWithCoords() {
      return this.companies.filter(company =>
        company.has_location === 1 &&
        company.lat !== null &&
        company.lng !== null &&
        !isNaN(parseFloat(company.lat)) &&
        !isNaN(parseFloat(company.lng))
      );
    },
    // NUEVO: Contar empresas sin coordenadas
    companiesWithoutCoords() {
      return this.companies.length - this.companiesWithCoords.length;
    },
    // NUEVO: Filtrar pacientes con coordenadas - CORREGIDO
    patientsWithCoords() {
      return this.patients.filter(patient => {
        // Verificar si el paciente tiene ubicación y coordenadas válidas
        const hasValidLocation = patient.has_location === 1 ||
                               (patient.lat !== null && patient.lng !== null);

        const hasValidCoords = patient.lat !== null &&
                             patient.lng !== null &&
                             !isNaN(parseFloat(patient.lat)) &&
                             !isNaN(parseFloat(patient.lng));

        return hasValidLocation && hasValidCoords;
      });
    },
    // NUEVO: Contar pacientes sin coordenadas
    patientsWithoutCoords() {
      return this.patients.length - this.patientsWithCoords.length;
    }
  },
  methods: {
    // Inicializar el mapa
    initMap() {
      this.mapLoading = true;
      this.mapReady = false;

      console.log('Inicializando mapa...');

      if (this.map) {
        this.map.remove();
      }

      // Crear el mapa
      this.map = L.map(this.$refs.mapContainer).setView(this.mapCenter, this.mapZoom);

      // Agregar capa de OpenStreetMap
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

      // Inicializar el grupo de clusters
      this.markerClusterGroup = L.markerClusterGroup({
        chunkedLoading: true,
        chunkInterval: 100,
        maxClusterRadius: 50,
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: true,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 16
      });

      // Agregar el grupo de clusters al mapa
      this.map.addLayer(this.markerClusterGroup);

      this.mapLoading = false;
      this.mapReady = true;
    },

    // Agregar marcadores al mapa - OPTIMIZADO CON CLUSTERING
    addMarkersToMap() {
      if (!this.map || !this.markerClusterGroup) {
        console.error('Mapa o grupo de clusters no inicializado');
        this.mapLoading = false;
        return;
      }

      console.log('Agregando', this.companiesWithCoords.length, 'empresas y', this.patientsWithCoords.length, 'pacientes al mapa con clustering');

      // Limpiar marcadores existentes del cluster
      this.markerClusterGroup.clearLayers();

      // Si no hay empresas ni pacientes, terminar la carga
      if (this.companiesWithCoords.length === 0 && this.patientsWithCoords.length === 0) {
        this.mapLoading = false;
        this.mapReady = true;
        console.log('No hay empresas ni pacientes con coordenadas para mostrar en el mapa');
        return;
      }

      // Procesar empresas en lotes para mejor rendimiento
      const batchSize = 1000;
      const totalCompanies = this.companiesWithCoords.length;
      const totalPatients = this.patientsWithCoords.length;
      const totalItems = totalCompanies + totalPatients;
      const totalBatches = Math.ceil(totalItems / batchSize);
      let processedBatches = 0;

      const processNextBatch = () => {
        if (processedBatches >= totalBatches) {
          // Todos los lotes procesados
          this.mapLoading = false;
          this.mapReady = true;
          console.log('Mapa completamente cargado con', totalCompanies, 'empresas y', totalPatients, 'pacientes con ubicación');

          // Ajustar el zoom para mostrar todos los marcadores si hay datos
          if (totalItems > 0) {
            setTimeout(() => {
              try {
                const bounds = this.markerClusterGroup.getBounds();
                if (bounds.isValid()) {
                  this.map.fitBounds(bounds.pad(0.1));
                }
              } catch (error) {
                console.warn('No se pudieron ajustar los límites del mapa:', error);
              }
            }, 500);
          }
          return;
        }

        const start = processedBatches * batchSize;
        const end = Math.min(start + batchSize, totalItems);

        // Combinar empresas y pacientes para el procesamiento por lotes
        const batchItems = [
          ...this.companiesWithCoords.slice(start, Math.min(end, totalCompanies)).map(item => ({ ...item, type: 'company' })),
          ...this.patientsWithCoords.slice(Math.max(0, start - totalCompanies), Math.max(0, end - totalCompanies)).map(item => ({ ...item, type: 'patient' }))
        ];

        this.processMarkerBatch(batchItems, processedBatches, this.markerClusterGroup);
        processedBatches++;

        // Usar setTimeout para no bloquear la UI
        setTimeout(processNextBatch, 50);
      };

      // Iniciar el procesamiento por lotes
      processNextBatch();
    },

    // Procesar un lote de marcadores - MEJORADO para manejar pacientes y empresas
    processMarkerBatch(items, batchIndex, clusterGroup) {
      const markers = [];

      items.forEach((item) => {
        // Convertir las coordenadas a números y validar
        let lat = item.lat;
        let lng = item.lng;

        // Si las coordenadas son strings, convertirlas a números
        if (typeof lat === 'string') {
          lat = parseFloat(lat);
        }
        if (typeof lng === 'string') {
          lng = parseFloat(lng);
        }

        // Validar que las coordenadas sean números válidos
        if (lat === null || lng === null || isNaN(lat) || isNaN(lng)) {
          console.warn('Coordenadas inválidas para:', item);
          return;
        }

        // Crear marcador con popup
        const marker = L.marker([lat, lng]);

        // Contenido del popup basado en el tipo (empresa o paciente)
        let popupContent = '';
        if (item.type === 'company') {
          popupContent = `
            <div style="min-width: 200px;">
              <strong>Empresa</strong><br>
              <small>Coords: ${lat.toFixed(4)}, ${lng.toFixed(4)}</small>
            </div>
          `;
        } else if (item.type === 'patient') {
          popupContent = `
            <div style="min-width: 200px;">
              <strong>Paciente</strong><br>
              <small>Ubicación en comuna</small><br>
              <small>Coords: ${lat.toFixed(4)}, ${lng.toFixed(4)}</small>
            </div>
          `;
        }

        marker.bindPopup(popupContent);

        // NUEVO: Iconos elegantes y llamativos para pacientes y empresas
        if (item.type === 'patient') {
          // Para pacientes, usar un icono elegante con efecto de pulso
          marker.setIcon(L.divIcon({
            className: 'patient-marker animated-marker pulse-marker',
            html: `
              <div class="marker-container patient-marker-container">
                <div class="marker-pulse"></div>
                <div class="marker-icon">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="white">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </div>
              </div>
            `,
            iconSize: [30, 30],
            iconAnchor: [15, 15]
          }));
        } else if (item.type === 'company') {
          // Para empresas, usar un icono diferente con efecto de brillo
          marker.setIcon(L.divIcon({
            className: 'company-marker animated-marker shine-marker',
            html: `
              <div class="marker-container company-marker-container">
                <div class="marker-pulse"></div>
                <div class="marker-icon">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="white">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                  </svg>
                </div>
              </div>
            `,
            iconSize: [30, 30],
            iconAnchor: [15, 15]
          }));
        }

        markers.push(marker);
      });

      // Agregar marcadores al grupo de clusters
      if (markers.length > 0) {
        clusterGroup.addLayers(markers);
      }

      console.log(`Lote ${batchIndex + 1} procesado: ${markers.length} marcadores`);
    },

    // NUEVO: Abrir mapa en pantalla completa usando modal
    openFullscreenMap() {
      if (!this.map) {
        console.error('El mapa principal no está inicializado');
        return;
      }

      // Obtener el estado actual del mapa
      const center = this.map.getCenter();
      const zoom = this.map.getZoom();

      // Abrir el modal
      this.$refs.fullscreenMap.open();

      // Inicializar el mapa en pantalla completa después de que el modal se abra
      this.$nextTick(() => {
        setTimeout(() => {
          this.initFullscreenMap(center, zoom);
        }, 300);
      });
    },

    // NUEVO: Inicializar mapa en pantalla completa
    initFullscreenMap(center, zoom) {
      try {
        // Limpiar mapa existente en pantalla completa
        if (this.fullscreenMap) {
          this.fullscreenMap.remove();
          this.fullscreenMap = null;
        }

        // Esperar a que el contenedor esté disponible
        const fullscreenContainer = document.getElementById('fullscreen-map-container');
        if (!fullscreenContainer) {
          console.error('Contenedor del mapa en pantalla completa no encontrado');
          return;
        }

        // Crear el mapa en pantalla completa
        this.fullscreenMap = L.map('fullscreen-map-container', {
          preferCanvas: true
        }).setView(center, zoom);

        // Agregar capa de OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          maxZoom: 18
        }).addTo(this.fullscreenMap);

        // Inicializar el grupo de clusters para pantalla completa
        this.fullscreenMarkerClusterGroup = L.markerClusterGroup({
          chunkedLoading: true,
          chunkInterval: 100,
          maxClusterRadius: 50,
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: true,
          zoomToBoundsOnClick: true,
          disableClusteringAtZoom: 16
        });

        // Agregar el grupo de clusters al mapa
        this.fullscreenMap.addLayer(this.fullscreenMarkerClusterGroup);

        // Forzar redimensionado después de que el modal esté completamente abierto
        setTimeout(() => {
          if (this.fullscreenMap) {
            this.fullscreenMap.invalidateSize();
            // Re-centrar el mapa después del redimensionamiento
            this.fullscreenMap.setView(center, zoom);
          }
        }, 400);

        // Agregar marcadores al mapa de pantalla completa
        this.addMarkersToFullscreenMap();

      } catch (error) {
        console.error('Error al inicializar mapa en pantalla completa:', error);
      }
    },

    // NUEVO: Agregar marcadores al mapa de pantalla completa
    addMarkersToFullscreenMap() {
      if (!this.fullscreenMap || !this.fullscreenMarkerClusterGroup) {
        console.error('Mapa de pantalla completa no inicializado');
        return;
      }

      console.log('Agregando marcadores al mapa de pantalla completa');

      // Limpiar marcadores existentes
      this.fullscreenMarkerClusterGroup.clearLayers();

      // Combinar empresas y pacientes con coordenadas
      const allItems = [
        ...this.companiesWithCoords.map(item => ({ ...item, type: 'company' })),
        ...this.patientsWithCoords.map(item => ({ ...item, type: 'patient' }))
      ];

      // Si no hay items, terminar
      if (allItems.length === 0) {
        return;
      }

      // Procesar en lotes para mejor rendimiento
      const batchSize = 1000;
      const totalBatches = Math.ceil(allItems.length / batchSize);
      let processedBatches = 0;

      const processNextBatch = () => {
        if (processedBatches >= totalBatches) {
          // Todos los lotes procesados
          console.log('Mapa de pantalla completa cargado con', allItems.length, 'marcadores');

          // Ajustar el zoom para mostrar todos los marcadores
          if (allItems.length > 0) {
            setTimeout(() => {
              if (this.fullscreenMap && this.fullscreenMarkerClusterGroup) {
                try {
                  const bounds = this.fullscreenMarkerClusterGroup.getBounds();
                  if (bounds.isValid()) {
                    this.fullscreenMap.fitBounds(bounds.pad(0.1));
                  }
                } catch (error) {
                  console.warn('No se pudieron ajustar los límites del mapa:', error);
                }
              }
            }, 500);
          }
          return;
        }

        const start = processedBatches * batchSize;
        const end = Math.min(start + batchSize, allItems.length);
        const batchItems = allItems.slice(start, end);

        this.processMarkerBatch(batchItems, processedBatches, this.fullscreenMarkerClusterGroup);
        processedBatches++;

        // Usar setTimeout para no bloquear la UI
        setTimeout(processNextBatch, 50);
      };

      // Iniciar el procesamiento por lotes
      processNextBatch();
    },

    // NUEVO: Cerrar mapa en pantalla completa
    closeFullscreenMap() {
      this.$refs.fullscreenMap.close();

      // Limpiar el mapa de pantalla completa
      if (this.fullscreenMap) {
        setTimeout(() => {
          this.fullscreenMap.remove();
          this.fullscreenMap = null;
          this.fullscreenMarkerClusterGroup = null;
        }, 300);
      }
    },

    async sendEmail() {
      this.process = true;
      console.log('log test', this.the_doctor.name + this.the_doctor.lastname2)
      this.form.name = this.the_doctor.specialities[0].name + " " + this.the_doctor.name + " " + this.the_doctor.lastname2
      if (!this.form.text) {
        this.form.text = 'Te invitamos a conocer a nuestro Prestador de Salud en convenio con ColaboraMed Atención preferencial con Bonificación hasta del 80% del Co-Pago, para pago online.'
      }
      let url = '/doctors/custom-email'
      try {
          const { data } = await this.form.post(url, {
              headers: {
                  Authorization : 'Bearer '+ this.$auth.getToken(),
              }
          })

          swal('Correo enviado con exito', '', 'success')

      } catch (e) {
        console.log('e', e.response);
          swal('Haz excedido tu límite de envío semanal de correos.', '', 'warning')
      }
    },

    getOfficeLocation(){
      let comunity = this.comunitySelected;
      if (!comunity || typeof comunity.lat == "undefined") {
        return false;
      }
      return {lat: parseFloat(comunity.lat), lng: parseFloat(comunity.lng)};
    },

    rounded(num){
      return Math.floor(num)
    },

    preview(item){
      this.preview_item = item
    },

    soon2(){
      this.$refs.snackbar.open();
    },

    soon(){
      this.openDialog("dialog1")
    },

    closeDialog(ref) {
      this.$refs[ref].close();
    },

    // Get patient_types
    getPatientTypes() {
      this.$http.get(admin.api.resources.patientTypes, {
              headers: {
                  Authorization : 'Bearer '+ this.$auth.getToken(),
              }
            })
        .then(response => {
          let data = response.data.data
          if (data.length) {
            data.map((item, index) => {
              item.value = item.id
              item.label = item.name
            })
            data.unshift({id: 0, name: '-- Convenio --'})
            this.datatable.filters.patient_types = data
            this.disabledPatientTypes = false
          }
        })
    },

    // Get previsions by country
    getPrevisionsUser(country) {
      this.$http.get(public_api.api.previsions + `?country=${country}`)
        .then(response => {
          let data = response.data.data
          if (data.length) {
            data.map((item, index) => {
              item.value = item.id
              item.label = item.display_name
            })
            this.previsions = data
            this.disabledPrevisions = false
          }
        })
    },

    // Get previsions by country
    getBoxesUser(country) {
      this.$http.get(public_api.api.boxes + `?country=${country}`)
        .then(response => {
          let data = response.data.data
          if (data.length) {
            data.map((item, index) => {
              item.value = item.id
              item.label = item.display_name
            })
            this.boxes = data
            this.disabledBoxes = false
          }
        })
    },

    submit(scope, type){
      var self = this;
      this.$validator.validateAll(scope)
        .then(function(result) {
          if (result) {
            self.patient_btn_edit = true;
            self.$http.put(admin.api.patients + '/update/' + self.patient_edit.id , self.patient_edit, {
                headers: {
                  Authorization: "Bearer " + self.$auth.getToken()
                }
              }).then(function(response){
                self.patient_btn_edit = false;
                let data_response = response.data.data;
                self.patients[self.currentIndex] = data_response
                self.closeDialog('editPatient');
                swal('', response.data.msg, 'success')
              }).catch(function(error){
                  self.patient_btn_edit = false;
                  if (error.response) {
                      let data = error.response.data;
                      if (error.response.status === 422) {
                          for (var index in data) {
                              var messages = "";
                              data[index].forEach(function(item) {
                                  messages += item + " ";
                              });
                              self._errors.errors.unshift({
                                  field: index,
                                  msg: messages,
                                  scope: scope
                              });
                          }
                      } else if (error.response.status === 401) {
                          self.errors.response.invalid = true;
                          self.errors.response.msg = "Datos incorrectos";
                      } else {
                          console.log(error);
                          alert("Error generic");
                      }
                  } else if (error.request) {
                      console.log(error.request);
                      alert("Error empty");
                  } else {
                      console.log("Error", error.message);
                      alert("Error");
                  }
              });
            }
        });
    },

    getDataGraphics(){
      this.$http.get(admin.api.graphics, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          this.graphs = data;
          this.graph_models =  [4, 0, 2, 3];
          this.graph_models.forEach(function(element, index) {
            this.updateGraph(index)
          }, this);
        })
    },

    formatNumber(value, coin) {
        if(coin == "CLP"){
          return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : 0
        }
        return value
    },

    openDialog(ref, row, rowIndex) {
      console.log(row);
      if(ref == "editPatient"){
          if(!this.hasPerm('patients/update')) {
            ref = "viewPatient";
          }
        }
      if(row){
        if(row.birth_date){
          let arr_date = row.birth_date.split('/');
          let birth_date = arr_date[2] + '-' + Number(arr_date[1]) + '-' + arr_date[0]
          row.birth_date = moment(birth_date, "YYYY-MM-DD").format();
          row.current_date = moment(birth_date, "YYYY-MM-DD").format();
        }else{
          row.birth_date = moment().format();
          row.current_date = moment().format();
        }
        this.patient_edit = row;
        this.currentIndex = rowIndex;
        this.getPrevisionsUser(row.country.countryCode)
        this.getBoxesUser(row.country.countryCode)
      }
      setTimeout(() => {
          this.$refs[ref].open();
      },250)
    },

    mailificator(row){
      let name = row.name +" " +(row.lastname ? row.lastname : '')+" " +(row.lastname2 ? row.lastname2 : '');
      let splited = name.split(" ");
      let email = splited.join(".")+"@gmail.com";
      return email.toLowerCase();
    },

    onOpen() {
      // console.log('Opened');
    },

    onClose(type) {
      // console.log('Closed', type);
    },

    generateRandomPoint(center, radius) {
      var x0 = center.lng;
      var y0 = center.lat;
      // Convert Radius from meters to degrees.
      var rd = radius/111300;

      var u = Math.random();
      var v = Math.random();

      var w = rd * Math.sqrt(u);
      var t = 2 * Math.PI * v;
      var x = w * Math.cos(t);
      var y = w * Math.sin(t);

      var xp = x/Math.cos(y0);

      // Resulting point.
      return {'lat': y+y0, 'lng': xp+x0};
    },

    getPosition(length, row, index){
        this.patientLoadingOff();
        this.mapZoom = 17
        console.log("center", row);
      let vary = 250
      if(this.datatable.filters.options.comunity_filter > 0 ){
        vary= Math.floor(Math.random() * (2020 - 10 + 1)) + 10;
      }
      console.log("variando en", vary)
      let coords = this.generateRandomPoint({lat: parseFloat(this.officeLocation.lat), lng: parseFloat(this.officeLocation.lng)  }, vary)
      this.mapCenter = {lat: parseFloat(row.lat), lng: parseFloat(row.lng)}
      return coords;
    },

    getPositionCoords(item) {
      let coords = {lat: parseFloat(item.lat), lng: parseFloat(item.lng)  }
       return coords;
    },

    // Method to search
    expensiveOperation: _.debounce(function () {
      this.getPatients()
    }, 500),

    // get Patietns - RESTAURADO: Ahora hace ambas peticiones como en el código anterior
    preprocessFilters(filters){
      let final_filters = {};
      for (var key in filters) {
        if (filters.hasOwnProperty(key)) {
          final_filters[key] = this.preprocessFilter(filters[key]);
        }
      }
      return final_filters;
    },

    preprocessFilter(filter){

      if(filter && typeof filter == "object" && (filter.value || filter.id) ){
        return filter.id ? filter.id : filter.value;
      }
      return filter;
    },

    patientLoadingOff(){
      setTimeout(function(){
        this.patientLoading = false;
      }.bind(this), 1000);
    },

    // RESTAURADO: Método getPatients completo que hace ambas peticiones - CORREGIDO
    getPatients(){
      this.patientLoading = true;
      let page = '';
      let filter = this.datatable.filters.options
      filter.row_selected = this.datatable.filters.row_selected
      let url = admin.api.patients

      console.log('Obteniendo pacientes para comuna:', this.datatable.filters.options.comunity_filter);

      // RESTAURADO: Petición para pacientes - CORREGIDA
      this.$http.post(url, filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;

          console.log('Respuesta de pacientes:', data);

          // USAR LOS DATOS REALES DEL BACKEND - NO SIMULAR
          this.patients = data.data || [];

          console.log("# pacientes cargados:", this.patients.length)
          console.log("# pacientes con coordenadas:", this.patientsWithCoords.length)

          // set pages
          this.datatable.filters.pages = {
            last_page: data.last_page,
            current_page: data.current_page,
            first_page: 1,
            next_page_url: data.next_page_url,
            prev_page_url: data.prev_page_url,
            total: data.total
          }

          // Petición para empresas (ya existente)
          this.$http.post(admin.api.companies, filter, {
            headers: {
              Authorization: "Bearer " + this.$auth.getToken()
            }
          }).then(response => {
            let data = response.data.data;
            this.companies = [];
            // this.companies = data.data || [];
            console.log("companies", this.companies)
            console.log("companies con coordenadas:", this.companiesWithCoords.length)

            // Actualizar el mapa con las nuevas empresas y pacientes
            if (this.map) {
              this.mapLoading = true;
              this.addMarkersToMap();
            }
            this.patientLoading = false;
          }).catch(error => {
            console.error('Error al obtener empresas:', error);
            this.companies = [];
            this.patientLoading = false;
            this.mapLoading = false;
          })

        }).catch(error => {
          console.error('Error al obtener pacientes:', error);
          this.patients = [];
          this.patientLoading = false;
          this.mapLoading = false;
        })
    },

    // set Total footer
    setTotalFooter(data){
      let total = {
        countries : []
      }
      let total_patients = data.data.length
      var self = this
      var pos = 0
      if(data.data.length){
        data.data.map( (patient,index) => {
          if(index == 0){
            let obj = {
              country: patient.country,
              currency: patient.country.currency,
              total: {reserve: 0, diary: 0, price: 0, discount: 0, final_price: 0},
              pos: pos
            }
            if(patient.reserves_count.length > 0){
                obj.total.reserve += patient.reserves_count[0].total_reserves
            }
            if(patient.diaries_count.length > 0){
              obj.total.diary += patient.diaries_count[0].total_diaries
            }
            if(patient.bonuses_total.length > 0){
              obj.total.price += patient.bonuses_total[0].total_price
              obj.total.discount += patient.bonuses_total[0].total_discount
              obj.total.final_price += patient.bonuses_total[0].total_final_price
            }
            total.countries.push(obj)
            pos++;
          }else{
            // filter index
            let country_search = total.countries.find(country => country.currency.id == patient.country.currency.id)
            if(typeof(country_search) != 'undefined'){
              let index_search = country_search.pos;
              if(patient.reserves_count.length > 0){
                total.countries[index_search].total.reserve += patient.reserves_count[0].total_reserves
              }
              if(patient.diaries_count.length > 0){
                total.countries[index_search].total.diary += patient.diaries_count[0].total_diaries
              }
              if(patient.bonuses_total.length > 0){
                total.countries[index_search].total.price += patient.bonuses_total[0].total_price
                total.countries[index_search].total.discount += patient.bonuses_total[0].total_discount
                total.countries[index_search].total.final_price += patient.bonuses_total[0].total_final_price
              }
            }else{
              let obj = {
                country: patient.country,
                currency: patient.country.currency,
                total: {reserve: 0, diary: 0, price: 0, discount: 0, final_price: 0},
                pos: pos
              }
              if(patient.reserves_count.length > 0){
                  obj.total.reserve += patient.reserves_count[0].total_reserves
              }
              if(patient.diaries_count.length > 0){
                obj.total.diary += patient.diaries_count[0].total_diaries
              }
              if(patient.bonuses_total.length > 0){
                obj.total.price += patient.bonuses_total[0].total_price
                obj.total.discount += patient.bonuses_total[0].total_discount
                obj.total.final_price += patient.bonuses_total[0].total_final_price
              }
              total.countries.push(obj)
              pos++;
            }
          }
          // set totals
          if(total_patients-1 == index){
            self.datatable.total = total
          }
        })
      }else{
        self.datatable.total = { countries: [] }
      }
    },

    // get count Patients
    getCountPatients(){
      this.$http.get(admin.api.patients_count, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          this.countPatients = data.total_patients
        })
    },

    // get Countries
    getCountries(){
      this.$http.get(admin.api.countries, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          let r_data = [{"id":3895114,"name":"Chile"}];
          r_data.unshift({id: 0, name: '-- País --'})
          this.datatable.filters.countries = r_data;
        })
    },

    // get Range age
    getRangeAge(){
      let limit = 105;
      this.datatable.filters.ages.push({label: 'Edad', value: null});
      for(let i = 0; i <= limit; i = i +5){

          this.datatable.filters.ages.push({label: i, value: i});
      }
    },

    getRegions(){
      this.$http.get(admin.api.regions + '/' + this.datatable.filters.options.country_filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          data.unshift({id: 0, name: '-- Provincia --'})
          this.datatable.filters.provinces = data;
        })
    },

    getComunities(){
       this.$http.get(doctor.api.offices,{
          headers: {
              Authorization : 'Bearer '+ this.$auth.getToken(),
          }
          }).then(response => {
              let data = response.data.data;
              console.log(data);
              let comunity_offices = [];
              data.forEach(function(v,i){
                comunity_offices.push({id: v.comunity_id, name: v.comunity, has_location: v.has_location, lat: v.lat, lng:v.lng})
              })
              this.datatable.filters.comunities = comunity_offices;
          }).catch(error => {
              if(!error.response)
              {
                  if(error.request.status == 0)
                  {
                      this.$router.push({'name':'logout'});
                  }
              }
          });
    },

    getPrevisions(){
      this.$http.get(admin.api.previsions + '/' + this.datatable.filters.options.country_filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          data.unshift({id: 0, name: '-- Prevision --'})
          this.datatable.filters.previsions = data;
        })
    },

    getBoxes(){
      this.$http.get(admin.api.boxes + '/' + this.datatable.filters.options.country_filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          data.unshift({id: 0, name: '-- Caja de Compensación --'})
          this.datatable.filters.boxes = data;
        })
    },

    getTotals(){
      this.$http.get('https://api.agendaenlinea.cl/api/stats').then(response => {
          let data = response.data;
          this.total_reserves = data.reserves.always;
          this.total_diaries = data.diaries.always;
        })

      this.$http.get(admin.api.patient_totals, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          this.totals = data;
        })
    },

    // Delete user
    remove(row, rowIndex){
      swal("Eliminar Paciente", "¿Esta seguro de eliminar el Paciente?", 'warning')
        .then( () => {
          this.$http.delete(admin.api.patient_remove + '/' + row.id, {
              headers: {
                  Authorization : 'Bearer '+ this.$auth.getToken(),
              }
            }).then(response => {
              let data = response.data.data;
              swal('', response.data.msg, 'success')
                .then( () => {
                  this.patients.splice(rowIndex, 1);
                  this.getPatients()
                }, (dismiss) => {
                  this.patients.splice(rowIndex, 1);
                  this.getPatients()
                });
          }).catch(error => {
            console.log(error);
          });
        }, (dismiss) => {
            //console.log(dismiss);
        })
    }
  },
  watch: {
    'datatable.filters.search.query': function () {
      this.expensiveOperation()
    },
    'datatable.filters.row_selected': function() {
      this.getPatients()
    },
    'datatable.filters.options.order_filter': function(){
      this.getPatients()
    },
    'datatable.filters.options.country_filter': function(){
      this.datatable.filters.options.province_filter = 0
      this.datatable.filters.options.comunity_filter = 0
      this.datatable.filters.options.prevision_filter = 0
      this.datatable.filters.options.box_filter = 0
      if(this.datatable.filters.options.country_filter > 0){
        // get regions
        this.getRegions()
      }else{
        this.datatable.filters.regions = []
        this.datatable.filters.previsions = []
        this.datatable.filters.boxes = []
      }
      this.datatable.filters.provinces = []
      this.datatable.filters.comunities = []
      this.getPatients()
    },
    'datatable.filters.options.province_filter': function(){
      console.log("change", this.datatable.filters.options.province_filter)
      this.datatable.filters.options.comunity_filter = 0
      if(this.datatable.filters.options.province_filter > 0){
        // get comunities
        this.getComunities()
      }else{
        this.datatable.filters.comunities = []
      }
      this.getPatients()
    },
    'datatable.filters.options.comunity_filter': function(){
      this.officeLocation = this.getOfficeLocation()
      this.getPatients()
    },
    'datatable.filters.options.prevision_filter': function(){
      this.getPatients()
    },
    'datatable.filters.options.box_filter': function(){
      this.getPatients()
    },
    'datatable.filters.options.gender_filter': function(){
      this.getPatients()
    },
    'datatable.filters.options.age_filter_lower': function(){
      this.getPatients()
    },
    'datatable.filters.options.age_filter_upper': function(){
      this.getPatients()
    },
    'datatable.filters.options.patient_type_filter': function(){
      this.getPatients()
    }
  },
  beforeDestroy() {
    // Limpiar los mapas
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    if (this.fullscreenMap) {
      this.fullscreenMap.remove();
      this.fullscreenMap = null;
    }
  }
}
</script>

<style lang="stylus">
@import '../../assets/styles/variables/color.styl'
@import '../../assets/styles/admin/style.styl'

.money_display, .money_display .md-table-cell-container
  margin-top 5px
  word-break keep-all
  white-space nowrap
  font-size 10px
.show_small
    display none
.table.table-patient-list
  .md-table-cell-container
    .bubble-gray
      margin-top 0 !important
      display inline-block !important
    .bubble-gray + .bubble-gray
      margin-top 6px !important
.table.table-patient-list
  .total-countries-list
    display flex
    flex-flow column nowrap
    align-items center
    justify-content center
  .total-reserves
    padding-top 5px

/* Estilos para el mapa */
.map-results {
  margin: 20px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  z-index: 1; /* Reducido para permitir que el diálogo esté encima */
}

.map-info {
  padding: 10px 20px;
  background: #f9f9f9;
  border-top: 1px solid #ddd;
}

.map-info p {
  margin: 5px 0;
  font-size: 14px;
}

/* Estados de carga del mapa */
.map-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border-radius: 4px;
}

.loading-content {
  text-align: center;
  padding: 20px;
}

.loading-content p {
  margin: 10px 0 0 0;
  color: #666;
}

.loading-detail {
  font-size: 12px !important;
  color: #999 !important;
}

.map-ready-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(76, 175, 80, 0.9);
  color: white;
  padding: 10px 15px;
  border-radius: 4px;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.ready-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ready-icon {
  color: white !important;
}

.ready-content p {
  margin: 0;
  font-size: 14px;
}

.ready-detail {
  font-size: 12px !important;
  opacity: 0.9;
}

/* NUEVO: Controles del mapa */
.map-controls {
  position: absolute;
  top: 80px;
  right: 10px;
  z-index: 1000;
  display: flex;
  gap: 5px;
}

.fullscreen-btn {
  background: white !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2) !important;
  width: 40px !important;
  height: 40px !important;
}

.fullscreen-btn:hover {
  background: #f5f5f5 !important;
}

/* NUEVO: Modal de mapa en pantalla completa */
.fullscreen-map-modal {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100% !important;
  max-height: 100% !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  z-index: 10002 !important;
}

.fullscreen-map-modal .md-dialog {
  width: 98vw !important;
  height: 70vm !important;
  max-width: 100% !important;
  max-height: 100% !important;
}

.fullscreen-map-modal .md-dialog-container {
  width: 100vw !important;
  height: 90% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  background: rgba(0, 0, 0, 0.9) !important;
}

.fullscreen-map-modal .md-overlay {
  z-index: 10001 !important;
  background: rgba(0, 0, 0, 0.9) !important;
}

/* Asegurar que el contenedor del mapa tenga dimensiones */
#fullscreen-map-container {
  position: relative !important;
  background: white;
  width: 100% !important;
  height: 100% !important;
  min-height: 100vh;
}

/* NUEVO: Estilos mejorados para marcadores elegantes y llamativos */
.animated-marker {
  background: transparent !important;
  border: none !important;
}

.marker-container {
  position: relative;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.patient-marker-container {
  background: linear-gradient(135deg, #2196F3, #1976D2);
}

.company-marker-container {
  background: linear-gradient(135deg, #4CAF50, #388E3C);
}

.marker-icon {
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(2px);
}

.marker-pulse {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  z-index: 1;
}

/* Efecto de pulso para marcadores */
.pulse-marker .marker-pulse {
  animation: pulse 2s infinite;
  background: inherit;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  70% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}

/* Efecto de brillo para marcadores */
.shine-marker .marker-container {
  animation: shine 3s infinite;
}

@keyframes shine {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
  50% {
    box-shadow: 0 4px 20px rgba(76, 175, 80, 0.6);
  }
}

/* Efecto hover para marcadores */
.animated-marker:hover .marker-container {
  transform: scale(1.2);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

/* Estilos para los clusters del mapa */
.marker-cluster-small {
  background-color: rgba(181, 226, 140, 0.8);
  border: 2px solid rgba(110, 204, 57, 0.8);
}
.marker-cluster-small div {
  background-color: rgba(110, 204, 57, 0.8);
  color: white;
  font-weight: bold;
}

.marker-cluster-medium {
  background-color: rgba(241, 211, 87, 0.8);
  border: 2px solid rgba(240, 194, 12, 0.8);
}
.marker-cluster-medium div {
  background-color: rgba(240, 194, 12, 0.8);
  color: white;
  font-weight: bold;
}

.marker-cluster-large {
  background-color: rgba(253, 156, 115, 0.8);
  border: 2px solid rgba(241, 128, 23, 0.8);
}
.marker-cluster-large div {
  background-color: rgba(241, 128, 23, 0.8);
  color: white;
  font-weight: bold;
}

.marker-cluster {
  background-clip: padding-box;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.marker-cluster div {
  width: 30px;
  height: 30px;
  margin-left: 5px;
  margin-top: 5px;
  text-align: center;
  border-radius: 15px;
  font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif;
}
.marker-cluster span {
  line-height: 30px;
}

/* NUEVO: Estilos para el diálogo para que esté por encima del mapa */
.md-dialog {
  z-index: 10010 !important;
}

.md-overlay {
  z-index: 10009 !important;
}

@media (max-width: 920px)
	.table.table-patient-list.table-responsive
		table
			thead th:nth-child(7)
			tbody td:nth-child(7)
				display none
			abbr
				display inline-block !important
			span.country
				display none
@media (max-width: 800px)
  .md-table-cell[data-name="Especialidades"] div
    text-align center !important

	.table.table-patient-list.table-responsive
		table
			thead th:nth-child(8)
			tbody td:nth-child(8)
				display none

@media (max-width: 768px)
	/* Listado de Pacientes =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
	.app-main .content-container
    .table.table-mobile-format
      thead
        th
          display none !important
      tbody
        td
          display none !important
        tr.md-table-row:nth-child(odd) .md-table-cell
          background-color #F5F5F5

      thead th.data-mobile
      tbody td.data-mobile
        display table-cell !important


@media (max-width: 520px)
	.app-main .content-container .space-between
		flex-flow row wrap
		.search-wrap
			margin-bottom 10px
		.table-options .filter-options .md-button
			margin-left 0 !important
	.app-main .content-container
		.table-options .filter-options .md-button
			margin-left 0 !important
		.table-results
			flex-flow column nowrap
			.google-maps-action
				padding-left 0
				padding-top 15px
				top 0
		.table.table-patient-list
			table
				td:nth-child(9)
					max-width 280px
					word-wrap break-word
	.table.table-patient-list.table-responsive
		table
			td
			th
				padding-left 85px
</style>
<style>
  md-field {
    width: 100%;
  }

@media(max-width:800px){
    .desktop_only {
        display: none;
    }
    .movil_only {
        margin-top:20px;
    }
}
@media(min-width:800px){
    .movil_only {
        display:none;
    }
}
.dSmbrN {
    position: relative;
    top: 250px;
    left: 32px;
    cursor: pointer;
}
.hQVZHz {
    box-shadow: rgb(212, 212, 213) 0px 1px 3px 0px;
    max-width: 360px;
    background-color: rgb(255, 255, 255);
    overflow-y: hidden;
    border-radius: 10px;
}
.hQVZHze {
    box-shadow: rgb(212, 212, 213) 0px 1px 3px 0px;
    width: 100%;
    max-width: 100%;
    background-color: rgb(255, 255, 255);
    overflow-y: hidden;
    border-radius: 10px;
    margin: auto;
}
.dgBCNv {
    width: 360px;
    box-shadow: rgb(212, 212, 213) 0px 1px 3px 0px;
    margin-top: 10px;
    border-radius: 10px;
}
.jiSlDO {
    color: rgb(85, 85, 85);
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    font-weight: 300;
    text-align: center;
    line-height: 20px;
    padding: 10px 10px 8px;
    border-bottom: none;
    border-radius: 10px 10px 0px 0px;
}
.eLaYeg {
    max-height: 350px;
    overflow-y: auto;
}
.bFdPyK:last-child {
    border-radius: 0px 0px 10px 10px;
    border-bottom: none;
}
.bFdPyK:first-child {
    border-radius: 10px 10px 0px 0px;
}
.bFdPyK {
    background-color: rgba(255, 255, 255, 0.3);
    width: 100%;
    text-align: center;
    padding: 15px 0px;
    border-bottom: 1px solid rgb(221, 221, 221);
}
.sc-fMiknA.enniBG {
    padding: 10px;
    padding-top: 5px;
}

.sc-fBuWsC.jLtcjp {
    padding: 10px;
    padding-bottom: 0px;
}
*, *:before, *:after {
  box-sizing: inherit;
}
html {
  box-sizing: border-box;
  height: 100%;
  margin: 0;
  padding: 0;
}
.loading {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #ffffffd6;
    z-index: 1000;
    font-weight: bolder;
    text-align: center;
    padding: 20px;
    top: 0;
}

.loading .md-progress {
    max-width: 500px;
    display: inline-block;
    margin-top: 25vh;
    height: 20px;
}

.loading span {
    display: block;
}
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Roboto", sans-serif;
  margin: 0;
  padding: 0;
  height: 100%;
}

.page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.marvel-device .screen {
  text-align: left;
}

.screen-container {
  height: 100%;
}

/* Status Bar */

.status-bar {
  height: 25px;
  background: #004e45;
  color: #fff;
  font-size: 14px;
  padding: 0 8px;
}

.status-bar:after {
  content: "";
  display: table;
  clear: both;
}

.status-bar div {
  float: right;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 0 0 8px;
  font-weight: 600;
}

/* Chat */

.chat {
  height: calc(100% - 69px);
}

.chat-container {
  height: 100%;
}

/* User Bar */

.user-bar {
  height: 55px;
  background: #005e54;
  color: #fff;
  padding: 0 8px;
  font-size: 24px;
  position: relative;
  z-index: 1;
}

.user-bar:after {
  content: "";
  display: table;
  clear: both;
}

.user-bar div {
  float: left;
  transform: translateY(-50%);
  position: relative;
  top: 50%;
}

.user-bar .actions {
  float: right;
  margin: 0 0 0 20px;
}

.user-bar .actions.more {
  margin: 0 12px 0 32px;
}

.user-bar .actions.attachment {
  margin: 0 0 0 30px;
}

.user-bar .actions.attachment i {
  display: block;
  transform: rotate(-45deg);
}

.user-bar .avatar {
  margin: 0 0 0 5px;
  width: 36px;
  height: 36px;
}

.user-bar .avatar img {
  border-radius: 50%;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.1);
  display: block;
  width: 100%;
}

.user-bar .name {
  font-size: 17px;
  font-weight: 600;
  text-overflow: ellipsis;
  letter-spacing: 0.3px;
  margin: 0 0 0 8px;
  overflow: hidden;
  white-space: nowrap;
  width: 110px;
}

.user-bar .status {
  display: block;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
}

/* Conversation */

.conversation {
  height: calc(100% - 12px);
  position: relative;
  background: #efe7dd url("https://cloud.githubusercontent.com/assets/398893/15136779/4e765036-1639-11e6-9201-67e728e86f39.jpg") repeat;
  z-index: 0;
}

.conversation ::-webkit-scrollbar {
  transition: all .5s;
  width: 5px;
  height: 1px;
  z-index: 10;
}

.conversation ::-webkit-scrollbar-track {
  background: transparent;
}

.conversation ::-webkit-scrollbar-thumb {
  background: #b3ada7;
}

.conversation .conversation-container {
  height: calc(100% - 68px);
  box-shadow: inset 0 10px 10px -10px #000000;
  overflow-x: hidden;
  padding: 0 16px;
  margin-bottom: 5px;
}

.conversation .conversation-container:after {
  content: "";
  display: table;
  clear: both;
}

/* Messages */

.message {
  color: #262626;
  clear: both;
  line-height: 18px;
  font-size: 15px;
  padding: 8px;
  position: relative;
  margin: 8px 0;
  max-width: 85%;
  word-wrap: break-word;
  z-index: -1;
}

.message:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
}

.metadata {
  display: inline-block;
  float: right;
  padding: 0 0 0 7px;
  position: relative;
  bottom: -4px;
}

.metadata .time {
  color: rgba(0, 0, 0, .45);
  font-size: 11px;
  display: inline-block;
}

.metadata .tick {
  display: inline-block;
  margin-left: 2px;
  position: relative;
  top: 4px;
  height: 16px;
  width: 16px;
}

.metadata .tick svg {
  position: absolute;
  transition: .5s ease-in-out;
}

.metadata .tick svg:first-child {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  -webkit-transform: perspective(800px) rotateY(180deg);
          transform: perspective(800px) rotateY(180deg);
}

.metadata .tick svg:last-child {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  -webkit-transform: perspective(800px) rotateY(0deg);
          transform: perspective(800px) rotateY(0deg);
}

.metadata .tick-animation svg:first-child {
  -webkit-transform: perspective(800px) rotateY(0);
          transform: perspective(800px) rotateY(0);
}

.metadata .tick-animation svg:last-child {
  -webkit-transform: perspective(800px) rotateY(-179.9deg);
          transform: perspective(800px) rotateY(-179.9deg);
}

.message:first-child {
  margin: 16px 0 8px;
}

.message.received {
  background: #fff;
  border-radius: 0px 5px 5px 5px;
  float: left;
}

.message.received .metadata {
  padding: 0 0 0 16px;
}

.message.received:after {
  border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0;
  left: -10px;
}

.message.sent {
  background: #e1ffc7;
  border-radius: 5px 0px 5px 5px;
  float: right;
}

.message.sent:after {
  border-width: 0px 0 10px 10px;
  border-color: transparent transparent transparent #e1ffc7;
  top: 0;
  right: -10px;
}

/* Compose */

.conversation-compose {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  overflow: hidden;
  height: 50px;
  width: 100%;
  z-index: 2;
}

.conversation-compose div,
.conversation-compose input {
  background: #fff;
  height: 100%;
}

.conversation-compose .emoji {
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 5px 0 0 5px;
  flex: 0 0 auto;
  margin-left: 8px;
  width: 48px;
}

.conversation-compose .input-msg {
  border: 0;
  flex: 1 1 auto;
  font-size: 16px;
  margin: 0;
  outline: none;
  min-width: 50px;
}

.conversation-compose .photo {
  flex: 0 0 auto;
  border-radius: 0 0 5px 0;
  text-align: center;
  position: relative;
  width: 48px;
}

.conversation-compose .photo:after {
  border-width: 0px 0 10px 10px;
  border-color: transparent transparent transparent #fff;
  border-style: solid;
  position: absolute;
  width: 0;
  height: 0;
  content: "";
  top: 0;
  right: -10px;
}

.conversation-compose .photo i {
  display: block;
  color: #7d8488;
  font-size: 24px;
  transform: translate(-50%, -50%);
  position: relative;
  top: 50%;
  left: 50%;
}

.conversation-compose .send {
  background: transparent;
  border: 0;
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: 8px;
  margin-right: 8px;
  padding: 0;
  position: relative;
  outline: none;
}

.conversation-compose .send .circle {
  background: #008a7c;
  border-radius: 50%;
  color: #fff;
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.conversation-compose .send .circle i {
  font-size: 24px;
  margin-left: 5px;
}

/* Small Screens */

@media (max-width: 768px) {
  .marvel-device.nexus5 {
    border-radius: 0;
    flex: none;
    padding: 0;
    max-width: none;
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  .marvel-device > .screen .chat {
    visibility: visible;
  }

  .marvel-device {
    visibility: hidden;
  }

  .marvel-device .status-bar {
    display: none;
  }

  .screen-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .conversation {
    height: calc(100vh - 55px);
  }
  .conversation .conversation-container {
    height: calc(100vh - 120px);
  }
}
.birth_filter .md-input-container {
    display: inline-grid;
}

.birth_filter .md-select.md-theme-default {
    display: inline;
}
.birth_filter label {
    position: relative !important;
}
.selected-tag + input.form-control {
    display: none !important;
}

.v-select {
    width: 200px !important;
    min-width: 200px !important;
}

.v-select button.clear,.v-select .open-indicator {
    line-height: 15px !important;
}
.md-input-container.select-border.filter-item {
    min-width: 210px !important;
}
</style>
<style scoped>
.md-select.md-theme-default {
  padding-left: 10px;
  height: 35px;
  border: 1px solid #e4e9f0;
  max-width: 100vw !important;
}

.page-charts {
  max-width: 100vw !important;
}
.main-content {
    padding: 15px !important;
}

.section-content.admin-content {
    max-width: 100vw !important;
}
.amol-picker{
  position: relative;
}
.amol-picker .required{
  color: #f26061;
}
@media (max-width: 600px){
    .chart-box {
        width: 100% !important;
        flex: 0 0 100% !important;
    }
}
.chart_button {
          margin-right: 10px !important;
    margin-left: 10px;
    border-radius: 4px;
    background-color: #bbedf1;
    margin: 20px 0;
    text-align: center
}
span.email_rec {
    float: left;
    margin-left: 5px;
}
 span.email_rec::after {
    content: ",";
}
 span.email_rec:last-child::after {
    content: " " !important;
}
total-stats .row {
  margin: 0 -15px;
  display: -moz-flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.total-stats .col-stats {
  padding: 15px;
  -moz-flex: 0 0 33.3%;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 33.3%;
          flex: 0 0 33.3%;
}
.total-stats .stat-item {
  border: 1px solid #d9d9d9;
  padding: 25px;
  width: 100%;
  border-radius: 4px;
}
.total-stats .stat-item h4 {
  font-size: 14px;
  text-transform: uppercase;
  color: #9da1a6;
  font-weight: 500;
  margin: 0;
}
.total-stats .stat-item .sign {
  opacity: 0.6;
  font-size: 20px;
  position: relative;
  top: -3px;
  padding-right: 4px;
  display: inline-block;
}
.total-stats .stat-item .type {
  padding-left: 4px;
  font-size: 15px;
  font-weight: 400;
  opacity: 0.5;
  display: inline-block;
}
.total-stats .stat-item h3.stat-price {
  margin: 5px 0 0 0;
  letter-spacing: -0.03em;
  font-size: 25px;
  font-weight: 700;
  color: #76be33;
}
.total-stats .stat-item.stat-saved {
  border-color: #76be33;
  background-color: #8bd248;
}
.total-stats .stat-item.stat-saved h4 {
  color: #d9efc4;
}
.total-stats .stat-item.stat-saved h3 {
  color: #fff;
}
.total-stats .stat-item.stat-debt {
  border-color: #f26061;
}
.total-stats .stat-item.stat-debt h3.stat-price {
  color: #f26061;
}
.total-stats .stat-item.stat-debt.stat-saved {
  background-color: #f26061;
  border-color: #f0484a;
}
.total-stats .stat-item.stat-debt.stat-saved h4 {
  color: #fff;
  opacity: 0.9;
}
.total-stats .stat-item.stat-debt.stat-saved h3.stat-price {
  color: #fff;
}

.md-input-container {
    margin: 0;
    width: calc(100% - 40px);
    margin-left: 20px;
}
@media(min-width:555px){
.col-stats {
    width: 50% !important;
    float: left !important;
}
}

</style>



// WEBPACK FOOTER //
// PatientCoords.vue?926448de